import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { apiFetch } from "../../api.js";
import Layout from "../../components/Layout.js";
import Select from "react-select";

const ModelMasterDetailsDesign = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const allowAlphabets = (value) => value.replace(/[^a-zA-Z ]/g, "");
  const [ModelDescription, setModelDescription] = useState("");
  const [Make, setMake] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [isEditMode, setIsEditMode] = useState(false);
  const [errors, setErrors] = useState({});
  const [gridErrors, setGridErrors] = useState({});
  const [Makelist, setMakelist] = useState([]);
  const [ipAddress, setIpAddress] = useState("");
  const [userId, setUserId] = useState("");
  const [serverIp] = useState(window.location.hostname);

  const storedUserInfo = JSON.parse(sessionStorage.getItem("userinfo")) || {};
  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: "40px",
      height: "40px",
      borderRadius: "5px",
      borderColor: "#ccc",
      boxShadow: "none",
    }),
    valueContainer: (base) => ({
      ...base,
      height: "40px",
      padding: "0 10px",
      display: "flex",
      alignItems: "center",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: "40px",
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
    }),
  };

  useEffect(() => {
    fetchMakes();
  }, []);

  const fetchMakes = async () => {
    try {
      const response = await apiFetch(
        "/api/model-master/makes",
      );
      const data = await response.json();
      const makes = data.map((item) => ({
        label: item.value,
        value: item.data,
      }));
      setMakelist(makes);
    } catch (error) {
      console.error("Error fetching makes:", error.message);
      alert("Failed to fetch Make list");
    }
  };

  useEffect(() => {
    apiFetch("/api/get-ip")
      .then((res) => res.json())
      .then((data) => setIpAddress(data.ip))
      .catch(() => setIpAddress("0.0.0.0"));
  }, []);

  useEffect(() => {
    const storedUserInfo = JSON.parse(sessionStorage.getItem("userinfo")) || {};
    setUserId(storedUserInfo.userId || "");
  }, []);

  useEffect(() => {
    if (location.state && location.state.editData) {
      const { editData } = location.state;
      setIsEditMode(true);
      setModelDescription(editData.model || "");
      setMake(editData.make || "");
      setIsActive(editData.active === true || editData.active === "Y");
      if (editData.variantRows && Array.isArray(editData.variantRows)) {
        const mappedRows = editData.variantRows.map((row) => ({
          varunq: row.varunq || "",
          variant: row.variant || "",
          fuel: row.fuel || "Select",
          code: row.code || "",
          cess: row.cess || "",
          gst: row.gst || "",
          rtorate: row.rtorate || "",
          rtotaxsur: row.rtotaxsur || "",
          greentax: row.greentax || "",
          odrate: row.odrate || "",
          thirdparty: row.thirdparty || "",
          zd: row.zd || "",
          pb: row.pb || "",
          kp: row.kp || "",
          ep: row.ep || "",
          fasttag: row.fasttag || "",
          handlingcharges: row.handlingcharges || "",
          RTO_OtherCity: row.RTO_OtherCity || "",
          numberplatecharge: row.numberplatecharge || "",
          registrationfee: row.registrationfee || "",
          paiddriver: row.paiddriver || "",
          pacover: row.pacover || "",
          smartcard: row.smartcard || "",
          other: row.other || "",
          duplicate: row.duplicate || "",
          hpn: row.hpn || "",
          horsePower: Number(row.horsepower) || 0,
          cylinders: Number(row.noofcylinders) || 0,
          seating: Number(row.seatingcapacity) || 0,
          unladenWeight: Number(row.unladenweight) || 0,
          grossWeight: Number(row.grossvehicleweight) || 0,
          bodyType: row.typeofbody || "",
          effdatef: row.effdatef || "",
          effdatet: row.effdatet || "",
          exshowroom: row.exshowroom || "",
          activestatus: row.activestatus,
        }));
        setGridRows(mappedRows);
      }
    }
  }, [location.state]);

  const handleExit = () => {
    navigate("/Modelmaster/grid");
  };

  const handleSave = async () => {
    if (!validateForm()) {
      alert("⚠️ Please fill all required fields before saving.");
      return;
    }
    const payload = {
      prefix: `MOD-${Date.now()}`,
      modelDescription: ModelDescription.trim(),
      makeId: Make,
      isActive: isActive,
      userId: userId,
      ipAddress: ipAddress,
      serverIp: serverIp,
      variants: gridRows.map((row) => ({
        variant: row.variant.trim(),
        fuel: row.fuel,
        horsePower: Number(row.horsePower) || 0,
        cylinders: Number(row.cylinders) || 0,
        seating: Number(row.seating) || 0,
        unladenWeight: Number(row.unladenWeight) || 0,
        grossWeight: Number(row.grossWeight) || 0,
        bodyType: row.bodyType.trim(),
        activestatus: row.activestatus,
      })),
    };
    try {
      const response = await apiFetch(
        "/api/model-master/save",
        { method: "POST", body: JSON.stringify(payload) },
      );
      const data = await response.json();
      alert(data.message);
      navigate("/Modelmaster/grid");
    } catch (error) {
      console.error("❌ Save error:", error);
      alert(`❌ ${error.message || "Failed to save. Please try again."}`);
    }
  };

  const [gridRows, setGridRows] = useState([
    {
      variant: "",
      horsePower: 0,
      cylinders: 0,
      seating: 0,
      unladenWeight: 0,
      grossWeight: 0,
      bodyType: "",
      activestatus: "Active",
      fuel: "Select",
    },
  ]);

  const fuelOptions = [
    "Select",
    "PETROL",
    "DIESEL",
    "LPG",
    "CNG",
    "CNG/PETROL",
    "Electric",
  ];

  const statusOptions = ["Select", "Active", "InActive"];
  const handleGridChange = (index, field, value) => {
    const newRows = [...gridRows];
    if (
      [
        "horsePower",
        "cylinders",
        "seating",
        "unladenWeight",
        "grossWeight",
      ].includes(field)
    ) {
      newRows[index][field] = value === "" ? 0 : Number(value);
    } else {
      newRows[index][field] = value;
    }
    setGridRows(newRows);
  };

  const handleUpdate = async () => {
    if (!validateForm()) {
      alert("⚠️ Please fill all required fields before updating.");
      return;
    }
    const modelId = location.state.editData.sp_202 || "";
    const payload = {
      prefix: modelId,
      modelDescription: ModelDescription.trim(),
      makeId: Make,
      isActive: isActive,
      variants: gridRows.map((row) => {
        console.log("Row inside map:", row);
        return {
          varunq: row.varunq || "",
          variant: row.variant.trim(),
          fuel: row.fuel,
          horsePower: Number(row.horsePower) || 0,
          cylinders: Number(row.cylinders) || 0,
          seating: Number(row.seating) || 0,
          unladenWeight: Number(row.unladenWeight) || 0,
          grossWeight: Number(row.grossWeight) || 0,
          bodyType: row.bodyType.trim(),
          activestatus: row.activestatus,
        };
      }),
    };
    try {
      const response = await apiFetch(
        "/api/model-master/update",
        { method: "POST", body: JSON.stringify(payload) },
      );
      const data = await response.json();
      alert(data.message || "✅ Model updated successfully!");
      navigate(-1);
    } catch (error) {
      console.error("❌ Update error:", error);
      alert(`❌ ${error.message || "Failed to update. Please try again."}`);
    }
  };

  const validateRow = (row, index) => {
    const rowErrors = {};
    if (!row.variant.trim()) rowErrors.variant = true;
    if (!row.horsePower) rowErrors.horsePower = true;
    if (!row.cylinders) rowErrors.cylinders = true;
    if (!row.seating) rowErrors.seating = true;
    if (!row.unladenWeight) rowErrors.unladenWeight = true;
    if (!row.grossWeight) rowErrors.grossWeight = true;
    if (!row.bodyType.trim()) rowErrors.bodyType = true;
    if (row.fuel === "Select") rowErrors.fuel = true;
    setGridErrors((prev) => ({ ...prev, [index]: rowErrors }));
    return Object.keys(rowErrors).length === 0;
  };

  const addGridRow = () => {
    const lastIndex = gridRows.length - 1;
    if (!validateRow(gridRows[lastIndex], lastIndex)) {
      alert(
        "⚠️ Please fill all fields in the current row before adding a new one.",
      );
      return;
    }

    setGridRows([
      ...gridRows,
      {
        varunq: "",
        variant: "",
        horsePower: 0,
        cylinders: 0,
        seating: 0,
        unladenWeight: 0,
        grossWeight: 0,
        bodyType: "",
        activestatus: "Active",
        fuel: "Select",
      },
    ]);
  };

  const validateForm = () => {
    let formErrors = {};
    if (!ModelDescription.trim()) formErrors.ModelDescription = true;
    if (!Make.trim()) formErrors.Make = true;
    setErrors(formErrors);
    let isGridValid = true;
    gridRows.forEach((row, index) => {
      if (!validateRow(row, index)) {
        isGridValid = false;
      }
    });
    return Object.keys(formErrors).length === 0 && isGridValid;
  };

  const inputStyle = (error) => ({
    padding: "10px",
    marginTop: "5px",
    borderRadius: "4px",
    border: error ? "2px solid red" : "1px solid #ccc",
    width: "100%",
    boxSizing: "border-box",
    fontSize: "14px",
  });

  const buttonContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap", // mobile friendly
    width: "100%",
    marginTop: "20px",
    position: "relative",
    zIndex: 10,
  };

  const buttonStyle = (bgColor) => ({
    minWidth: "120px", // ✅ same width everywhere
    height: "42px",
    padding: "0 20px",
    backgroundColor: bgColor,
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
    whiteSpace: "nowrap", // ✅ no text breaking
  });
  return (
    <Layout>
      <div className="page-container">
        <div className="container">
          <div className="header">Model Master</div>

          {/* Form Section */}
          <div className="form-row">
            <div className="form-column">
              <label>Model Description</label>
              <input
                type="text"
                value={ModelDescription}
                onChange={(e) =>
                  setModelDescription(allowAlphabets(e.target.value))
                }
                style={inputStyle(errors.ModelDescription)}
              />
            </div>

            <div className="form-column">
              <label>Make</label>
              <Select
                classNamePrefix="rs"
                options={Makelist}
                value={Makelist.find((o) => o.value === Make) || null}
                onChange={(selected) => setMake(selected?.value || "")}
                styles={customStyles}
                placeholder="Select Make"
                isSearchable
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>

            <div className="form-column">
              <label>Status</label>
              <div className="status-toggle">
                <label>Inactive</label>
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={isActive}
                    onChange={() => setIsActive(!isActive)}
                  />
                  <span className="slider round"></span>
                </label>
                <label>Active</label>
              </div>
            </div>
          </div>

          {/* Grid Section */}
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th style={{ width: "5%" }}>S.N.</th>
                  <th style={{ display: "none" }}>VarUnq</th>{" "}
                  {/* 🔹 Hidden column */}
                  <th style={{ width: "15%" }}>Variant</th>
                  <th>Horse Power</th>
                  <th>No of Cylinders</th>
                  <th>Seating Capacity</th>
                  <th>Unladen Weight</th>
                  <th>Gross Vehicle Weight</th>
                  <th style={{ width: "15%" }}>Type of Body</th>
                  <th>Status</th>
                  <th>Fuel</th>
                  {/*   <th>Action</th> */}
                </tr>
              </thead>
              <tbody>
                {gridRows.map((row, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td style={{ display: "none" }}>{row.varunq}</td>{" "}
                    {/* 🔹 Hidden value */}
                    {[
                      "variant",
                      "horsePower",
                      "cylinders",
                      "seating",
                      "unladenWeight",
                      "grossWeight",
                      "bodyType",
                    ].map((field) => (
                      <td key={field}>
                        <input
                          type={
                            [
                              "horsePower",
                              "cylinders",
                              "seating",
                              "unladenWeight",
                              "grossWeight",
                            ].includes(field)
                              ? "number"
                              : "text"
                          }
                          min={0}
                          value={row[field]}
                          onChange={(e) => {
                            let value = e.target.value;
                            if (
                              [
                                "horsePower",
                                "cylinders",
                                "seating",
                                "unladenWeight",
                                "grossWeight",
                              ].includes(field)
                            ) {
                              const num = Number(value);
                              value = isNaN(num) || num < 0 ? 0 : num;
                            }

                            handleGridChange(index, field, value);
                          }}
                          style={inputStyle(gridErrors[index]?.[field])}
                        />
                      </td>
                    ))}
                    <td>
                      <select
                        value={row.activestatus}
                        onChange={(e) =>
                          handleGridChange(
                            index,
                            "activestatus",
                            e.target.value,
                          )
                        }
                        style={inputStyle(gridErrors[index]?.activestatus)}
                      >
                        {statusOptions.map((f, i) => (
                          <option key={i} value={f}>
                            {f}
                          </option>
                        ))}
                      </select>
                    </td>
                    <td>
                      <select
                        value={row.fuel}
                        onChange={(e) =>
                          handleGridChange(index, "fuel", e.target.value)
                        }
                        style={inputStyle(gridErrors[index]?.fuel)}
                      >
                        {fuelOptions.map((f, i) => (
                          <option key={i} value={f}>
                            {f}
                          </option>
                        ))}
                      </select>
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan="11" style={{ textAlign: "right" }}>
                    <button
                      style={{
                        background: "blue",
                        color: "white",
                        border: "none",
                        padding: "8px 15px",
                        cursor: "pointer",
                        marginTop: "10px",
                      }}
                      onClick={addGridRow}
                    >
                      Add New Row
                    </button>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>

          {/* Buttons */}
          <div style={buttonContainerStyle}>
            {!isEditMode && (
              <button style={buttonStyle("#4caf50")} onClick={handleSave}>
                Save
              </button>
            )}
            {isEditMode && (
              <button style={buttonStyle("#2e20abff")} onClick={handleUpdate}>
                Update
              </button>
            )}

            <button style={buttonStyle("#ab2025")} onClick={handleExit}>
              Exit
            </button>
          </div>
        </div>
      </div>

      <style>
        {`
/* ================================
   react-select FIX
================================ */
.rs__menu-portal {
  z-index: 9999 !important;
}

/* ================================
   PAGE LAYOUT
================================ */
.page-container {
  width: 100%;
  min-height: 100vh;
  background: #f4f6f8;
  display: flex;
  justify-content: center;
  padding: 12px;
  box-sizing: border-box;
}

.container {
  width: 100%;
  max-width: 100%;
  background: #fff;
  border-radius: 8px;
  padding: 18px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  box-sizing: border-box;
}

/* ================================
   HEADER
================================ */
.header {
  text-align: center;
  font-size: 1.6rem;
  font-weight: 700;
  padding: 14px;
  background: linear-gradient(90deg, #8B1E3F, #8B1E3F);
  color: #fff;
  border-radius: 6px;
  margin-bottom: 20px;
}

/* ================================
   FORM GRID
================================ */
.form-row {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 15px;
  margin-bottom: 15px;
}

.form-column {
  display: flex;
  flex-direction: column;
}

.form-column label {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 5px;
}

/* ================================
   STATUS TOGGLE
================================ */
.status-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 6px;
}

/* ================================
   TABLE
================================ */
.table-container {
  overflow-x: auto;
  margin-top: 25px;
  border-radius: 6px;
}

table {
  width: max-content;
  min-width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  table-layout: fixed;
}

th {
  background: #ff353561;
  border: 1px solid #ccc;
  padding: 8px;
  text-align: center;
  white-space: nowrap;
}

td {
  border: 1px solid #ccc;
  padding: 6px;
  text-align: center;
  min-width: 110px;
}

/* ================================
   BUTTONS
================================ */
.button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin-top: 22px;
  flex-wrap: wrap;
}

/* ================================
   TOGGLE SWITCH
================================ */
.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 24px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  inset: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 24px;
}

.slider:before {
  content: "";
  position: absolute;
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background: #fff;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #4caf50;
}

input:checked + .slider:before {
  transform: translateX(26px);
}

/* ================================
   RESPONSIVE BREAKPOINTS
================================ */

/* Tablet */
@media (max-width: 992px) {
  .form-row {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  table {
    font-size: 13px;
  }
}

/* Mobile */
@media (max-width: 480px) {
  .form-row {
    grid-template-columns: 1fr;
  }

  table {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }

  .header {
    font-size: 1.3rem;
  }
}
`}
      </style>
    </Layout>
  );
};

export default ModelMasterDetailsDesign;
